export default "<worker-page\n  [worker-id]=\"workerId\"\n  [provider-id]=\"providerId\"\n  [close-callback]=\"closeCallback\"\n></worker-page>\n";